import { useBatchedSimplePerson } from "@/-dataloaders/simple-persons"

export function PersonName({ personId }: { personId: number }) {
  const { data: person } = useBatchedSimplePerson(personId)
  return person?.name
}
